import { useSuspenseQuery } from "@tanstack/react-query";
import { route } from "../../../../../shim/jsbridge";
import { sampleReportKeys } from "../../../queryKeys";
import api from "../../../api";

const useGetMutexData = (hash?: string, uploadId?: string) => {
  const endpoint = hash
    ? route(`api_joe_mutexes`, [hash])
    : route(`api_joe_url_mutexes`, [uploadId]);

  const { data } = useSuspenseQuery({
    queryKey: sampleReportKeys.mutexData(endpoint),
    queryFn: () => api.getDynamicAnalysisData<Array<unknown>>(endpoint),
    select: ({ data: mutexData }) => mutexData
  });

  return { data };
};

export default useGetMutexData;
